var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#008FDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.868 11.8732C22.6909 11.7098 22.459 11.6281 22.2283 11.6281C22.2009 11.6281 22.1872 11.6281 22.1602 11.6281C22.1465 11.6281 21.9968 11.6417 21.7653 11.6417C21.3704 11.6417 20.6219 11.6144 19.9009 11.4376C18.9749 11.2202 17.8996 10.1992 17.5864 9.99473C17.437 9.89933 17.2462 9.84497 17.0691 9.84497C16.8923 9.84497 16.7156 9.89933 16.5521 9.99473C16.5115 10.0221 15.3955 11.1788 14.3065 11.4376C13.585 11.6144 12.8092 11.6417 12.4283 11.6417C12.1832 11.6417 12.0338 11.6281 12.0201 11.6281C12.0064 11.6281 11.9791 11.6281 11.9657 11.6281C11.7206 11.6281 11.5028 11.7098 11.326 11.8732C11.1356 12.0367 11.0269 12.2815 11.0269 12.5266V14.7856C11.0269 23.1157 16.6749 24.1903 16.9064 24.2313C16.9607 24.245 17.0155 24.245 17.0695 24.245C17.1238 24.245 17.1789 24.245 17.2333 24.2313C17.4781 24.1903 23.1535 23.1153 23.1535 14.7856V12.5266C23.1535 12.2815 23.044 12.0367 22.868 11.8732ZM20.7717 15.0992L16.8653 18.8824C16.838 18.9235 16.811 18.9645 16.7699 18.9919C16.6609 19.1006 16.5115 19.1549 16.3617 19.1549C16.2116 19.1549 16.0622 19.1006 15.9398 18.9919C15.9124 18.9645 15.8721 18.9238 15.8581 18.8824L13.7621 16.8545C13.5443 16.6367 13.5443 16.2969 13.7621 16.0791C13.9796 15.8609 14.3471 15.8609 14.5649 16.0791L16.3617 17.8075L19.9685 14.3234C20.2004 14.1056 20.5535 14.1056 20.7713 14.3234C21.0028 14.5275 21.0028 14.8814 20.7717 15.0992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.72cbbce4e745050ec8bd3926d96e424c.svg";
export { ForwardRef as ReactComponent };